import { z } from 'zod';
/** Egy tuzelo Prometheus-riasztas, ahogy a szuperadmin megkapja. */
export const firingAlertSchema = z.object({
    /** Nev + cimkek - ket kulonbozo worker hibaja ket riasztas. */
    fingerprint: z.string(),
    name: z.string(),
    severity: z.enum(['critical', 'warning']),
    summary: z.string(),
    labels: z.record(z.string(), z.string()),
    startedAt: z.string(),
});
//# sourceMappingURL=alerts.js.map